import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiService } from "../api.service";

@Injectable({
  providedIn: "root",
})
export class VendorService {
  tickets: any = {};
  vendor: any = {};
  promise: any = {};
  products: any = {};
  matrimonyDetails: any = {
    about_self: '',
    about_family: '',
    about_partner: '',
  };
  interviewSchedule: any = {};
  registrationData: any;
  matriDetails: any = []
  matriVendorDetails: any = {}
  advertiseDetails: any = {}

  vendorTicketDetails: any = {}
  // options = { dialogdisplay: false, spinnerdisplay: false }
  companyDetails: any = {}
  clearData() {
    this.tickets = {};
    this.vendor = {};
    this.promise = {};
    this.matrimonyDetails = {};
    this.interviewSchedule = {};
    this.registrationData = null;
    this.matriDetails = [];
  }

  // vendorDetails:any ={}

  // vendor_id
  private vendorIdSubject = new BehaviorSubject<any | null>({});
  vendorIdSubject$ = this.vendorIdSubject.asObservable();

  setVendorIdSubject(obj: any | null) {
    this.vendorIdSubject.next(obj);
  }

  // vendor-registration
  setRegistrationData(data: any): void {
    this.registrationData = data;
  }

  getRegistrationData(): any {
    return this.registrationData;
  }
  /*  private agentDataSubject = new BehaviorSubject<any>(null);
   agentData$ = this.agentDataSubject.asObservable();
 
   setAgentData(data: any) {
     this.agentDataSubject.next(data);
   }
 
   getAgentData() {
     return this.agentDataSubject.getValue();
   } */



  private vendorDetails = new BehaviorSubject<any | null>({});
  vendorDetails$ = this.vendorDetails.asObservable();

  setVendorDetails(obj: any | null) {
    this.vendorDetails.next(obj);
  }

  private interviewerDetails = new BehaviorSubject<any | null>({});
  interviewerDetails$ = this.interviewerDetails.asObservable();

  setInterviewerDetails(obj: any | null) {
    this.interviewerDetails.next(obj);
  }

  private headersDetails = new BehaviorSubject<any | null>({});
  headersDetails$ = this.headersDetails.asObservable();

  setHeadersDetails(obj: any | null) {
    this.headersDetails.next(obj);
  }

  private planDetails = new BehaviorSubject<any | null>({});
  planDetails$ = this.planDetails.asObservable();

  setplanDetails(obj: any | null) {
    this.planDetails.next(obj);
  }

  private churchId = new BehaviorSubject<any | null>({});
  churchIdSubject$ = this.churchId.asObservable();

  setchurchIdSubject(obj: any | null) {
    this.churchId.next(obj);
  }

  // private matrimonyDetails = new BehaviorSubject<any | null>({});
  // matrimonyDetailsSubject$ = this.matrimonyDetails.asObservable();

  // setmatrimonyDetailsSubject(obj: any | null) {
  //   this.matrimonyDetails.next(obj);
  // }

  private rowDetails = new BehaviorSubject<any | null>({});
  rowDetailsSubject$ = this.rowDetails.asObservable();

  rowDetailsSubject(rowDetails: any | null) {
    this.rowDetails.next(rowDetails);
  }

  private userMatriProfileSubject = new BehaviorSubject<any | null>({});
  userMatriProfileSubject$ = this.userMatriProfileSubject.asObservable();

  setvalidateAdminSubject(uuid: any | null) {
    this.userMatriProfileSubject.next(uuid);
  }
  /*getOrder*/
  private jobPlansData: any[] = [];
  private matriPlansData: any[] = [];

  setPlans(jobPlans: any[], matriPlans: any[]): void {
    this.jobPlansData = jobPlans;
    this.matriPlansData = matriPlans;
  }

  getJobPlans(): any[] {
    return this.jobPlansData;
  }

  getMatriPlans(): any[] {
    return this.matriPlansData;
  }
  constructor(private http: HttpClient, private api: ApiService) { }

  vendorRegistration(data: any) {

    return this.api.POST_BR(environment.VENDOR_APIS.vendorRegistration, data);
  }

  emailVendorVerification(data: any) {
    let verify_key = data.verify_key;
    return this.api.GET_BR(environment.VENDOR_APIS.emailVendorVerification + "?verify_key=" + verify_key, data);
  }

  validateVendor(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.validateVendor, data);
  }
  updateVendorDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateVendorDetails, data);
  }
  uploadProfilePic(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadProfilePic, data);
  }
  updateProfilePic(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateProfilePic, data);
  }
  uploadMatriProfilePic(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadMatriProfilePic, data);
  }
  forgotPassword(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.forgotPassword, data);
  }
  createChurch(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createChurch, data);
  }
  updateVendorChurch(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateVendorChurch, data);
  }
  getChurches(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getChurches, data);
  }
  getCountries(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getCountries, data);
  }
  userGetAllOccupation(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAllOccupation, data);
  }

  uploadLogo(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadLogo, data);
  }

  createChurchAddress(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createChurchAddress, data);
  }

  // matrimonail
  createMatrimonialPersonalProfile(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createMatrimonialPersonalProfile, data);
  }
  updatePersonal(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updatePersonal, data);
  }
  createPhysical(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createPhysical, data);
  }

  createEmployment(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmployment, data);
  }

  createMaritalInfo(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createMaritalInfo, data);
  }

  createAddress(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createAddress, data);
  }

  // createVendorMatriAddress(data: any) {
  //   return this.api.POST_BR(
  //     environment.VENDOR_APIS.createVendorMatriAddress,
  //     data
  //   );
  // }
  // createPreference(data: any) {
  //   return this.api.POST_BR(environment.VENDOR_APIS.createPreference, data);
  // }

  createEducation(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEducation, data);
  }

  createFamily(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createFamily, data);
  }

  createPreference(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createPreference, data);
  }

  // uploadAvatar(data: any) {
  //   return this.api.POST_BR(environment.VENDOR_APIS.uploadAvatar, data);
  // }

  getMatProfile(data: any) {
    let uuid = data.uuid;
    return this.api.POST_BR(
      environment.VENDOR_APIS.getMatProfile + "?uuid=" + uuid,
      data
    );
  }
  getMatriProfilesByVendorId(data: any) {
    let vendor_uuid = data.vendor_uuid;
    return this.api.GET_BR(environment.VENDOR_APIS.getMatriProfilesByVendorId, data);
  }

  getFilterMatProfiles(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.getFilterMatProfiles,
      data
    );
  }

  getPartnerProfileByUuid(data: any) {
    let profile_uuid = data.profile_uuid;
    return this.api.POST_BR(environment.VENDOR_APIS.getPartnerProfileByUuid + "?profile_uuid=" + profile_uuid, data);
  }
  createProfileInterest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProfileInterest, data);
  }
  createProfileShortlist(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProfileShortlist, data);
  }
  createProfileBlocked(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProfileBlocked, data);
  }

  matriSearchUserProfiles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.matriSearchUserProfiles, data);
  }
  createProfileVisit(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProfileVisit, data);
  }
  getProfileYouVisited(data: any) {
    // let vendor_uuid = data.vendor_uuid;
    return this.api.GET_BR(environment.VENDOR_APIS.getProfileYouVisited, data);
  }
  getProfileShortListed(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getProfileShortListed, data);
  }
  removeProfileShortlisted(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.removeProfileShortlisted, data);
  }
  getBlockedProfiles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getBlockedProfiles, data);
  }
  unBlockProfile(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.unBlockProfile, data);
  }
  getProfileMyInterest(data: any) {
    let vendor_uuid = data.vendor_uuid;
    return this.api.GET_BR(environment.VENDOR_APIS.getProfileMyInterest, data);
  }

  getAllWeeklyServices(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllWeeklyServices, data);
  }

  createWeeklyServices(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createWeeklyServices, data);
  }

  updateWeeklyServices(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateWeeklyServices, data);
  }

  deleteWeeklyServices(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteWeeklyServices, data);
  }

  getAllTestimonies(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllTestimonies, data);
  }

  createTestimony(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createTestimony, data);
  }

  deleteTestimony(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteTestimony, data);
  }

  updateTestimony(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateTestimony, data);
  }

  createMinistries(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createMinistries, data);
  }

  updateMinistry(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateMinistry, data);
  }

  deleteMinistry(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteMinistry, data);
  }

  getActiveHobbies(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getActiveHobbies, data);
  }

  getAllMinistries(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllMinistries, data);
  }
  createGalleryMaster(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createGalleryMaster, data);
  }

  updateGalleryMaster(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateGalleryMaster, data);
  }

  deleteGalleryMaster(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteGalleryMaster, data);
  }

  getAllGalleryMaster(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllGalleryMaster, data);
  }
  createChurchGallery(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createChurchGallery, data);
  }

  updateChurchGallery(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateChurchGallery, data);
  }

  deleteChurchGallery(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteChurchGallery, data);
  }

  getAllChurchGallery(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllChurchGallery, data);
  }



  // chruch roles
  createChurchRole(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createChurchRole, data);
  }
  getAllChurchRoles(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllChurchRoles, data);
  }
  updateChurchRoles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateChurchRoles, data);
  }
  deleteChurchRoles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteChurchRoles, data);
  }

  // daily promises
  getAllChurchDailyPromises(data: any) {
    return this.api.GET_BR(
      environment.VENDOR_APIS.getAllChurchDailyPromises,
      data
    );
  }

  createChurchDailyPromises(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.createChurchDailyPromises,
      data
    );
  }

  updateChurchDailyPromises(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.updateChurchDailyPromises,
      data
    );
  }

  deleteChurchDailyPromises(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.deleteChurchDailyPromises,
      data
    );
  }
  initiateJobOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.initiateJobOrder, data);
  }
  createJobPurchageOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createJobPurchageOrder, data);
  }

  initiateMatriOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.initiateMatriOrder, data);
  }
  createPurchageOrderMatri(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createPurchageOrderMatri, data);
  }

  createCompanyOrBureauProfileBeforePayment(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createCompanyOrBureauProfileBeforePayment, data);
  }

  // transactions
  getAllTransactionOrders(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getAllTransactionOrders + "?uuid=" + uuid, data
    );
  }

  // orders
  getOrders(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getOrders + "?uuid=" + uuid,
      data
    );
  }

  // change password
  changePassword(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.changePassword, data);
  }

  // active plans
  getActivePlans(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getActivePlans, data);
  }

  // vendor company profile
  createVendorDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createVendorDetails, data);
  }
  updateCompanySocialLinks(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateCompanySocialLinks, data);
  }
  uploadCompanyLogo(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadCompanyLogo, data);
  }
  createCompanyDocuments(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.createCompanyDocuments,
      data
    );
  }
  getAllCompanyDocuments(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllCompanyDocuments, data);
  }
  createJobCandRestriction(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.createJobCandRestriction,
      data
    );
  }
  //jobs
  createJobPosting(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createJobPosting, data);
  }
  getAllJobPostings(data: any) {
    // let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getAllJobPostings,
      data
    );
  }
  getAllJobType(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllJobType, data);
  }

  getCompanyDetailsByVendorId(data: any) {
    // let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getCompanyDetailsByVendorId,
      data
    );
  }

  createSupportTicket(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createSupportTicket, data);
  }

  getSupportTickets(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getSupportTickets + "?uuid=" + uuid,
      data
    );
  }

  appliedJobs(data: any) {
    let id = data.id;
    return this.api.GET_BR(
      environment.VENDOR_APIS.appliedJobs + "?job_id=" + id,
      data
    );
  }

  getAllAppliedJobs(data: any) {
    let vendor_id = data.vendor_id;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getAllAppliedJobs + "?vendor_id=" + vendor_id,
      data
    );
  }

  createInterviewFeedback(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.createInterviewFeedback,
      data
    );
  }

  updateJobPosting(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateJobPosting, data);
  }

  deleteJobPosting(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteJobPosting, data);
  }

  validateInterviewer(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.validateInterviewer, data);
  }

  // getFeedbackByJobId(data: any) {
  //   let id = data.id
  //   return this.api.GET_BR(environment.VENDOR_APIS.getFeedbackByJobId + "?job_id=" + id, data);
  // }
  getFeedbackByJobId(data: any) {
    let uuid = data.uuid,
      job_id = data.job_id;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getFeedbackByJobId +
      "?uuid=" +
      uuid +
      "&job_id=" +
      job_id,
      data
    );
  }
  getMySchedules(data: any) {
    let interviewer_uuid = data.interviewer_uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getMySchedules +
      "?interviewer_uuid=" +
      interviewer_uuid,
      data
    );
  }

  getFeedbackForm(data: any) {
    let interviewer_uuid = data.interviewer_uuid,
      job_id = data.job_id,
      round_id = data.round_id;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getFeedbackForm + "?interviewer_uuid=" + interviewer_uuid + "&job_id=" + job_id + "&round_id=" + round_id,
      data
    );
  }

  getAllJobs(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getAllJobs + "?uuid=" + uuid,
      data
    );
  }

  createInterviewSchedule(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.createInterviewSchedule,
      data
    );
  }

  getSchedulesByJobId(data: any) {
    let uuid = data.uuid;
    let user_uuid = data.user_uuid,
      job_id = data.job_id;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getSchedulesByJobId +
      "?uuid=" +
      uuid +
      "&user_uuid=" +
      user_uuid +
      "&job_id=" +
      job_id,
      data
    );
  }

  createInterviewAnswers(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.createInterviewAnswers,
      data
    );
  }

  getConsolidateForm(data: any) {
    let uuid = data.uuid,
      job_id = data.job_id,
      user_uuid = data.user_uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getConsolidateForm + "?uuid=" + uuid + "&user_uuid=" + user_uuid + "&job_id=" +
      job_id,
      data
    );
  }

  getVendorProfileById(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getVendorProfileById + "?uuid=" + uuid,
      data
    );
  }

  generateEmailOTP(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.generateEmailOTP, data);
  }
  validateEmailOTP(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.validateEmailOTP, data);
  }

  generateMobileOTP(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.generateMobileOTP, data);
  }
  validateMobileOTP(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.validateMobileOTP, data);
  }

  vendorFinalReview(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.vendorFinalReview, data);
  }
  generateEmail(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.generateEmail, data);
  }
  createEmployee(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmployee, data);
  }
  uploadEmployeePic(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadEmployeePic, data);
  }
  getAllEmployees(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getAllEmployees + "?uuid=" + uuid,
      data
    );
  }
  getEmailsByVendorId(data: any) {
    let from_uuid = data.from_uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getEmailsByVendorId + "?from_uuid=" + from_uuid,
      data
    );
  }
  getActiveEmployees(data: any) {
    return this.api.GET_BR(
      environment.VENDOR_APIS.getActiveEmployees,
      data
    );
  }



  jobReviewStatus(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.jobReviewStatus, data);
  }
  assignEmployee(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.assignEmployee, data);
  }

  generateEmployeeEmailOTP(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.generateEmployeeEmailOTP,
      data
    );
  }
  validateEmployeeEmailOTP(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.validateEmployeeEmailOTP,
      data
    );
  }

  generateEmployeeMobileOTP(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.generateEmployeeMobileOTP,
      data
    );
  }
  validateEmployeeMobileOTP(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.validateEmployeeMobileOTP,
      data
    );
  }
  changeEmployeePassword(data: any) {
    return this.api.POST_BR(
      environment.VENDOR_APIS.changeEmployeePassword,
      data
    );
  }
  employeeResendMail(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.employeeResendMail, data
    );
  }
  getEmployeeProfileById(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getEmployeeProfileById + "?uuid=" + uuid,
      data
    );
  }

  getEmailsByVendorIdAndUserId(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getEmailsByVendorIdAndUserId, data);
  }
  downloadInvoice(data: any) {
    let order_id = data.order_id
    let module = data.module
    let plan_id = data.plan_id
    return this.api.GET_BLOB(environment.VENDOR_APIS.downloadInvoice + "?order_id=" + order_id + "&module=" + module + "&plan_id=" + plan_id, data);
  }


  // Matri Publish and Unpublish apis
  setMatrimonyProfileUnPublish(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.setMatrimonyProfileUnPublish, data);
  }

  setMatrimonyProfilePublish(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.setMatrimonyProfilePublish, data);
  }

  //shop
  createProduct(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProduct, data);
  }
  updateProduct(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateProduct, data);
  }
  deleteProduct(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteProduct, data);
  }
  getAllProducts(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllProducts, data);
  }
  getFilteredProducts(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getFilteredProducts, data);
  }
  createProductPhotos(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProductPhotos, data);
  }
  updateProductPhotos(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateProductPhotos, data);
  }
  getProductPhotos(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getProductPhotos, data);
  }

  // colors
  getProductColor(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getProductColor, data);
  }
  createProductColor(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProductColor, data);
  }
  updateProductColor(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateProductColor, data);
  }
  deleteProductColor(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteProductColor, data);
  }

  // size
  createProductSize(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProductSize, data);
  }
  getProductSize(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getProductSize, data);
  }

  // uom
  createProductUom(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createProductUom, data);
  }
  updateProductUom(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateProductUom, data);
  }
  deleteProductUom(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteProductUom, data);
  }
  getProductUom(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getProductUom, data);
  }

  employeeForgotPassword(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.employeeForgotPassword, data);
  }
  interviewerForgotPassword(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.interviewerForgotPassword, data);
  }
  interviewerchangePassword(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.interviewerchangePassword, data);
  }

  interviewerResendMail(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.interviewerResendMail, data);
  }
  deleteEmployee(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmployee, data);
  }

  setProfilePicThumbnail(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.setProfilePicThumbnail, data);
  }

  deleteProfilePic(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteProfilePic, data);
  }


  createInterviewRound(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createInterviewRound, data);
  }
  getActiveInterviewRound(data: any) {
    let job_id = data.job_id
    return this.api.GET_BR(environment.VENDOR_APIS.getActiveInterviewRound + "?job_id=" + job_id, data);
  }

  updateInterviewRound(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateInterviewRound, data);
  }
  createJobAdverts(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createJobAdverts, data);
  }
  deleteScheduleByJobId(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteScheduleByJobId, data);
  }
  candidateResendMail(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.candidateResendMail, data);
  }

  getAllJobAdverts(data: any) {
    //let job_id = data.job_id
    return this.api.GET_BR(environment.VENDOR_APIS.getAllJobAdverts, data);
  }
  updateJobAdverts(data: any) {
    //let job_id = data.job_id
    return this.api.POST_BR(environment.VENDOR_APIS.updateJobAdverts, data);
  }
  deleteJobAdverts(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteJobAdverts, data);
  }

  uploadAdvertsImage(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadAdvertsImage, data);
  }

  getActiveJobPostions(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getActiveJobPostions, data);
  }
  createExam(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createExam, data);
  }
  createQuestion(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createQuestion, data);
  }
  initiateDbPlansOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.initiateDbPlansOrder, data);
  }
  createDbPurchageOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createDbPurchageOrder, data);
  }
  getAllExam(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllExam, data);
  }
  getAvailableCandidateProfiles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getAvailableCandidateProfiles, data);
  }
  getCandidateProfile(data: any) {
    let seeker_uuid = data.seeker_uuid
    return this.api.GET_BR(environment.VENDOR_APIS.getCandidateProfile + "?seeker_uuid=" + seeker_uuid, data);

  }

  vendorAcceptInterest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.vendorAcceptInterest, data);
  }
  vendorDeclineInterest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.vendorDeclineInterest, data);
  }
  initiateAdvertPlansOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.initiateAdvertPlansOrder, data);
  }
  createAdvertPurchageOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createAdvertPurchageOrder, data);
  }
  candidateSaveProfile(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.candidateSaveProfile, data);
  }
  getCandidateSavedProfiles(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getCandidateSavedProfiles, data);
  }
  createJobsAdvertsApplication(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createJobsAdvertsApplication, data);
  }
  advertsSearchBySlug(data: any) {
    let slug = data.slug
    return this.api.GET_BR(environment.VENDOR_APIS.advertsSearchBySlug + "?slug=" + slug, data);

  }

  downloadMatriInvoice(data: any) {
    let order_id = data.order_id
    return this.api.GET_BLOB(environment.VENDOR_APIS.downloadMatriInvoice + "?order_id=" + order_id, data);
  }
  downloadDbInvoice(data: any) {
    let order_id = data.order_id
    return this.api.GET_BLOB(environment.VENDOR_APIS.downloadDbInvoice + "?order_id=" + order_id, data);
  }
  downloadAdvertInvoice(data: any) {
    let order_id = data.order_id
    return this.api.GET_BLOB(environment.VENDOR_APIS.downloadAdvertInvoice + "?order_id=" + order_id, data);
  }

  appliedAdvertJobs(data: any) {
    let advert_uuid = data.advert_uuid
    return this.api.GET_BR(environment.VENDOR_APIS.appliedAdvertJobs + "?advert_uuid=" + advert_uuid, data);

  }
  getAllJobAdvertsByVendorId(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllJobAdvertsByVendorId, data);

  }
  initiateOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.initiateOrder, data);
  }
  createPurchaseOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createPurchaseOrder, data);
  }
  freePusrchaseOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.freePusrchaseOrder, data);
  }

  createJobInterviewMode(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createJobInterviewMode, data);
  }
  createJobWorkLocation(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createJobWorkLocation, data);
  }

  getJobLocationsById(data: any) {
    let job_ref_id = data.job_ref_id
    return this.api.GET_BR(environment.VENDOR_APIS.getJobLocationsById + "?job_ref_id=" + job_ref_id, data);

  }
  deleteJobLocationByid(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteJobLocationByid, data);
  }

  createVendorCompany(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createVendorCompany, data);
  }
  updateContactDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateContactDetails, data);
  }
  updateCompanyAddress(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateCompanyAddress, data);
  }

  createVendorCompanyBranch(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createVendorCompanyBranch, data);
  }
  updateVendorCompanyBranch(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateVendorCompanyBranch, data);
  }
  deleteBranchByCompanyId(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteBranchByCompanyId, data);
  }

  getBranchesByCompanyId(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getBranchesByCompanyId, data);
  }

  createJobDescription(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createJobDescription, data);
  }
  updateJobInterviewMode(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateJobInterviewMode, data);
  }
  getTransactiondata(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getTransactiondata, data);
  }
  planInitiateOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.planInitiateOrder, data);
  }
  createPlanPurchaseOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createPlanPurchaseOrder, data);
  }

  getAppModuleMaster(data: any) {
    return this.api.GET_BR(environment.ADMIN_APIS.getAppModuleMaster, data);
  }

  updateInterviewSchedule(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateInterviewSchedule, data);
  }
  getVendorJobData(data: any) {
    let cadence = data.cadence
    return this.api.GET_BR(environment.VENDOR_APIS.getVendorJobData + "?cadence=" + cadence, data);
  }

  createBureau(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createBureau, data);
  }

  createBureauDocuments(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createBureauDocuments, data);
  }

  deleteBureauDocuments(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteBureauDocuments, data);
  }

  getBureauDetailsByVendorId(data: any) {
    let cadence = data.cadence
    return this.api.GET_BR(environment.VENDOR_APIS.getBureauDetailsByVendorId, data);
  }

  updateBureauContactDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateBureauContactDetails, data);
  }
  updateBureauAddress(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateBureauAddress, data);
  }
  uploadBureauLogo(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadBureauLogo, data);
  }
  updateBureauSocialLinks(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateBureauSocialLinks, data);
  }

  getBranchesByBureauId(data: any) {
    let cadence = data.cadence
    return this.api.GET_BR(environment.VENDOR_APIS.getBranchesByBureauId, data);
  }

  getReferralName(data: any) {
    let reg_id = data.reg_id
    return this.api.GET_BR(environment.VENDOR_APIS.getReferralName + "?reg_id=" + reg_id, data);
  }
  createDemo(data: any) {

    return this.api.POST_BR(environment.VENDOR_APIS.createDemo, data);
  }
  vendorApplicationRegistration(data: any) {

    return this.api.POST_BR(environment.VENDOR_APIS.vendorApplicationRegistration, data);
  }
  getInvoiceByOrderId(data: any) {
    let order_id = data.order_id
    return this.api.GET_BR(environment.VENDOR_APIS.getInvoiceByOrderId + "?order_id=" + order_id, data);
  }

  updateResumeRepositoryCandidateProfiles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateResumeRepositoryCandidateProfiles, data);
  }
  checkUserProfile(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.checkUserProfile, data);
  }

  createQNAs(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createQNAs, data);
  }

  updateQNAs(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateQNAs, data);
  }


  getQNAs(data: any) {
    let job_ref_id = data.job_ref_id
    return this.api.GET_BR(environment.VENDOR_APIS.getQNAs + "?job_ref_id=" + job_ref_id, data);
  }

  deleteQNAs(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteQNAs, data);
  }

  deleteCompanyDocuments(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteCompanyDocuments, data);
  }

  checkVendorEmail(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.checkVendorEmail, data);
  }
  checkVendorMobile(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.checkVendorMobile, data);
  }

  updateCompanyTaxDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateCompanyTaxDetails, data);
  }

  vendorInterviewersList(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.vendorInterviewersList, data);
  }

  createVendorInterviewPanel(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createVendorInterviewPanel, data);
  }

  getAllBureauDocuments(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllBureauDocuments, data);
  }

  deleteInterviewRound(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteInterviewRound, data);
  }

  deleteVendorInterviewPanel(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteVendorInterviewPanel, data);
  }

  shareMatriProfiles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.shareMatriProfiles, data);
  }

  updateCompanyDocuments(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateCompanyDocuments, data);
  }
  checkMatriProfileId(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.checkMatriProfileId, data);
  }

  checkInterviewerEmail(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.checkInterviewerEmail, data);
  }

  updateBureauTaxDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateBureauTaxDetails, data);
  }

  updateExam(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateExam, data);
  }
  getAllQuestions(data: any) {
    let exam_code = data.exam_code
    return this.api.GET_BR(environment.VENDOR_APIS.getAllQuestions + "?exam_code=" + exam_code, data);
  }

  submitExam(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.submitExam, data);
  }

  getPlanPurchasedFeatures(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getPlanPurchasedFeatures, data);
  }

  getMatriSharedProfiles(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMatriSharedProfiles, data);
  }
  getMembersVisitedYou(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMembersVisitedYou, data);
  }

  getMatriProfileAccessRequest(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMatriProfileAccessRequest, data);
  }

  updateMatriProfileAccesssRequest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateMatriProfileAccesssRequest, data);

  }
  startExam(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.startExam, data);
  }

  getVendorProfile(data: any) {
    let slug = data.slug
    return this.api.GET_BR(environment.VENDOR_APIS.getVendorProfile + "?slug=" + slug, data);
  }
  createBureauFollow(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createBureauFollow, data);
  }


  downloadInvoiceJobsFreePlan(data: any) {

    let module = data.module
    let invoice_no = data.invoice_no
    return this.api.GET_BLOB(environment.VENDOR_APIS.downloadInvoiceJobsFreePlan + "?module=" + module + "&invoice_no=" + invoice_no, data);
  }

  applyCoupon(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.applyCoupon, data);
  }
  getBureauFollow(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getBureauFollow, data);
  }
  getVendorJobsDashboard(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getVendorJobsDashboard, data);
  }
  createAnonymousUser(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createAnonymousUser, data);
  }
  createAnonymousInterviewSchedule(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createAnonymousInterviewSchedule, data);
  }

  updateAnonymousInterviewSchedule(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateAnonymousInterviewSchedule, data);
  }


  getAnonymousInterviewSchedule(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAnonymousInterviewSchedule, data);
  }
  startExamAnonymous(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.startExamAnonymous, data);
  }
  submitExamAnonymous(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.submitExamAnonymous, data);
  }
  getAppearedResultsByExamCode(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getAppearedResultsByExamCode, data);
  }

  getVendorJobsATS(data: any) {
    let job_status = data.job_status

    return this.api.GET_BR(environment.VENDOR_APIS.getVendorJobsATS + "?job_status=" + job_status, data);
  }
  uploadVendorDocuments(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadVendorDocuments, data);
  }
  getVendorDocumentsB4Approval(data: any) {
    let verify_key = data.verify_key
    let status = data.skip

    return this.api.GET_BR(environment.VENDOR_APIS.getVendorDocumentsB4Approval + "?verify_key=" + verify_key + "&skip=" + status, data);
  }
  getUserMatriPlans(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getUserMatriPlans, data);
  }

  initiateMatriMobileOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.initiateMatriMobileOrder, data);
  }
  checkPlanValidity(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.checkPlanValidity, data);
  }
  createEmpEducation(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpEducation, data);
  }
  updateEducation(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEducation, data);
  }
  createExperience(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createExperience, data);
  }
  updateExperience(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateExperience, data);
  }
  createDesignationEmp(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createDesignationEmp, data);
  }
  getAllDesignationEmp(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllDesignationEmp, data);
  }
  updateDesignationEmp(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateDesignationEmp, data);
  }
  deleteDesignationEmp(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteDesignationEmp, data);
  }
  createDepartmentEmp(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createDepartmentEmp, data);
  }
  getAllDepartmentsEmp(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllDepartmentsEmp, data);
  }
  updateDepartmentEmp(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateDepartmentEmp, data);
  }

  deleteDepartmentEmp(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteDepartmentEmp, data);
  }

  createShift(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createShift, data);
  }
  getAllShift(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllShift, data);
  }
  updateShift(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateShift, data);
  }

  deleteShift(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteShift, data);
  }
  getAttendanceCalendar(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getAttendanceCalendar, data);
  }

  createSalaryComponents(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createSalaryComponents, data);
  }

  updateSalaryComponent(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateSalaryComponent, data);
  }
  deleteSalaryComponent(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteSalaryComponent, data);
  }
  getAllSalaryComponents(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllSalaryComponents, data);
  }
  createOrUpdateEmpAddress(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createOrUpdateEmpAddress, data);
  }
  createOrUpdateEmpFamilyDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createOrUpdateEmpFamilyDetails, data);
  }

  createEmpSalaries(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpSalaries, data);
  }
  getEmpSalaries(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpSalaries, data);
  }
  updateEmpSalaries(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpSalaries, data);
  }
  deleteEmpSalaries(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpSalaries, data);
  }
  createEmpTypes(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpTypes, data);
  }
  getEmpTypes(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpTypes, data);
  }
  updateEmpTypes(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpTypes, data);
  }
  deleteEmpTypes(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpTypes, data);
  }


  getPendingLeaveRequests(data: any) {
    let uuid = data.uuid;
    return this.api.GET_BR(
      environment.VENDOR_APIS.getPendingLeaveRequests + "?uuid=" + uuid,
      data
    );
  }
  validateEmployee(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.validateEmployee, data);
  }
  getAllApprovalMgrs(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllApprovalMgrs, data);
  }
  bulkAttendanceUpload(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.bulkAttendanceUpload, data);
  }
  createEmpLeaveRequests(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpLeaveRequests, data);
  }
  updateEmpLeaveRequestsByMgr(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpLeaveRequestsByMgr, data);
  }
  getMyLeaveRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMyLeaveRequests, data);
  }

  getAllHrmsEmployees(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getAllHrmsEmployees, data);
  }

  updateEmpApprovalMgrs(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpApprovalMgrs, data);
  }
  approveEmpShiftRequestByMgr(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.approveEmpShiftRequestByMgr, data);
  }
  createEmpShiftRequest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpShiftRequest, data);
  }
  getPendingShiftRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getPendingShiftRequests, data);
  }
  getMyShiftRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMyShiftRequests, data);
  }
  getEmployeeDetailsByEmpCode(data: any) {
    let emp_code = data.emp_code
    return this.api.GET_BR(environment.VENDOR_APIS.getEmployeeDetailsByEmpCode + "?emp_code=" + emp_code, data);
  }

  createEmpBankDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpBankDetails, data);
  }

  updateEmpBankDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpBankDetails, data);
  }

  getStateCodesForHolidays(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getStateCodesForHolidays, data);
  }

  bulkHolidayCalendarUpload(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.bulkHolidayCalendarUpload, data);
  }
  updateStateCodesForHolidays(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateStateCodesForHolidays, data);
  }

  bulkAttendanceCreate(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.bulkAttendanceCreate, data);
  }

  createEmpPassportDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpPassportDetails, data);
  }
  createReimbursement(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createReimbursement, data);
  }

  addItems(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.addItems, data);
  }
  submitReimbursement(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.submitReimbursement, data);
  }
  managerApproval(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.managerApproval, data);
  }
  updateEmpPassportDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpPassportDetails, data);
  }
  financeApproval(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.financeApproval, data);
  }
  markAsPaid(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.markAsPaid, data);
  }
  uploadAttachment(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadAttachment, data);
  }
  getAttachments(data: any) {
    let reimbursement_id = data.reimbursement_id
    return this.api.GET_BR(environment.VENDOR_APIS.getAttachments + "?reimbursement_id=" + reimbursement_id, data);
  }
  deleteAttachment(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteAttachment, data);
  }
  getAllReimbursements(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllReimbursements, data);
  }


  getPendingReimbursementRequests(data: any) {
    //let emp_code = data.emp_code
    return this.api.GET_BR(environment.VENDOR_APIS.getPendingReimbursementRequests, data);
  }
  updateEmpRequestsByMgr(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpRequestsByMgr, data);
  }
  uploadDocumentsByEmp(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadDocumentsByEmp, data);
  }
  getDocumentsByEmpCode(data: any) {
    let emp_code = data.emp_code
    return this.api.GET_BR(environment.VENDOR_APIS.getDocumentsByEmpCode + "?emp_code=" + emp_code, data);
  }
  deleteDocumentById(data: any) {
    let id = data.id
    return this.api.POST_BR(environment.VENDOR_APIS.deleteDocumentById + "?id=" + id, data);
  }
  getPendingFinanceRequests(data: any) {
    let emp_code = data.emp_code
    return this.api.GET_BR(environment.VENDOR_APIS.getPendingFinanceRequests + "?emp_code=" + emp_code, data);
  }
  getMyReimbursementRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMyReimbursementRequests, data);
  }
  getMyFinanceRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMyFinanceRequests, data);
  }
  getEvaluationEligibilityEmployees(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEvaluationEligibilityEmployees, data);
  }



  createEmployeeLeaveType(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmployeeLeaveType, data);
  }
  getEmployeeLeaveType(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmployeeLeaveType, data);
  }
  updateEmployeeLeaveType(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmployeeLeaveType, data);
  }
  deleteEmployeeLeaveType(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmployeeLeaveType, data);
  }


  createEmpOt(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpOt, data);
  }
  getEmpOt(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpOt, data);
  }
  updateEmpOt(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpOt, data);
  }
  deleteEmpOt(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpOt, data);
  }

  getShiftOtDetails(data: any) {
    let shift_type = data.shift_type
    return this.api.GET_BR(environment.VENDOR_APIS.getShiftOtDetails + "?shift_type=" + shift_type, data);
  }

  cancelEmpLeaveRequest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.cancelEmpLeaveRequest, data);
  }
  createEmpSalaryComponents(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpSalaryComponents, data);
  }

  getAllEmpSalaryComponents(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllEmpSalaryComponents, data);
  }

  createEmpShiftDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpShiftDetails, data);
  }

  updateReimbursementById(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateReimbursementById, data);
  }

  createEmpSeparation(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpSeparation, data);
  }

  updateEmpSeparation(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpSeparation, data);
  }

  getEmpSeparation(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpSeparation, data);
  }

  getPendingApprovals(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getPendingApprovals, data);
  }


  managerActionSeparation(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.managerActionSeparation, data);
  }
  getManagerSeparations(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getManagerSeparations, data);
  }
  getHrmsDashboard(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getHrmsDashboard, data);
  }

  createEmpAssetsDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpAssetsDetails, data);
  }
  updateEmpAssetsDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpAssetsDetails, data);
  }
  getEmpAssetsDetails(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpAssetsDetails, data);
  }
  getEmpAssets(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpAssets, data);
  }
  getAssetsByCategory(data: any) {
    let category_id = data.category_id
    return this.api.GET_BR(environment.VENDOR_APIS.getAssetsByCategory + "?category_id=" + category_id, data);
  }

  createEmpRole(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpRole, data);
  }
  getEmpRoles(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpRoles, data);
  }
  updateEmpRole(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpRole, data);
  }
  deleteEmpRole(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpRole, data);
  }

  createEmpKpiDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpKpiDetails, data);
  }
  createEmpKpiHeadlines(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpKpiHeadlines, data);
  }
  getEmpKpiDetails(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpKpiDetails, data);
  }
  createEmpKpiSubtitles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpKpiSubtitles, data);
  }
  updateEmpKpiDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpKpiDetails, data);
  }
  updateEmpKpiSubtitles(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpKpiSubtitles, data);
  }
  getEvaluationFormByYear(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getEvaluationFormByYear, data);
  }
  createEmpCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpCategories, data);
  }
  getEmpCategories(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpCategories, data);
  }
  updateEmpCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpCategories, data);
  }
  deleteEmpCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpCategories, data);
  }

  createEmpAssets(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpAssets, data);
  }

  deleteEmpAssets(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpAssets, data);
  }
  updateEmpAssets(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpAssets, data);
  }
  getEmpCategoryAssetsDetails(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getEmpCategoryAssetsDetails, data);
  }

  createEmpAssignedAssets(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpAssignedAssets, data);
  }

  initiateHrmsOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.initiateHrmsOrder, data);
  }
  createHrmsPurchaseOrder(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createHrmsPurchaseOrder, data);
  }

  getEmpServiceCategories(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpServiceCategories, data);
  }
  createEmpServiceCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpServiceCategories, data);
  }

  updateEmpServiceCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpServiceCategories, data);
  }
  deleteEmpServiceCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpServiceCategories, data);
  }


  getEmpServiceSubCategories(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpServiceSubCategories, data);
  }
  createEmpServiceSubCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpServiceSubCategories, data);
  }

  updateEmpServiceSubCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpServiceSubCategories, data);
  }
  deleteEmpServiceSubCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpServiceSubCategories, data);
  }
  getActiveHRMSEmployees(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getActiveHRMSEmployees, data);
  }
  createEmpServiceRequest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpServiceRequest, data);
  }
  getEmpServiceRequest(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpServiceRequest, data);
  }


  getSubCategoriesByCategoryId(data: any) {
    let category_id = data.category_id
    return this.api.GET_BR(environment.VENDOR_APIS.getSubCategoriesByCategoryId + "?category_id=" + category_id, data);
  }
  updateCompanyProject(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateCompanyProject, data);
  }
  createCompanyProject(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createCompanyProject, data);
  }
  deleteCompanyProject(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteCompanyProject, data);
  }
  getAllCompanyProjects(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getAllCompanyProjects, data);
  }

  submitEmpKpiEvaluationForm(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.submitEmpKpiEvaluationForm, data);
  }
  createRtwCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createRtwCategories, data);
  }
 
  updateRtwCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateRtwCategories, data);
  }

  deleteRtwCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteRtwCategories, data);
  }
  getRtwCategories(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getRtwCategories, data);
  }
   createEmpRtwRequest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpRtwRequest, data);
  }
  getEmpRtwRequest(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpRtwRequest, data);
  }
  getMyRtwRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMyRtwRequests, data);
  }

    createEmpTransportRequest(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpTransportRequest, data);
  }
  getEmpTransportRequest(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpTransportRequest, data);
  }
  approveEmpTransportRequestByMgr(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.approveEmpTransportRequestByMgr, data);
  }
  getMyTransportRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getMyTransportRequests, data);
  }
  getPendingTransportRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getPendingTransportRequests, data);
  }
  approveEmpRtwRequestByMgr(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.approveEmpRtwRequestByMgr, data);
  }
  getPendingRtwRequests(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getPendingRtwRequests, data);
  }
  updateEmployee(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmployee, data);
  }
  updateDesignationHierarchy(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateDesignationHierarchy, data);
  }

  uploadEmployeeRecognition(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.uploadEmployeeRecognition, data);
  }
  getEmployeeRecognition(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmployeeRecognition, data);
  }

   downloadHrmsInvoice(data: any) {
    let order_id = data.order_id

    return this.api.GET_BLOB(environment.VENDOR_APIS.downloadHrmsInvoice + "?order_id=" + order_id, data);
  }
   setApprovalMgr(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.setApprovalMgr, data);
  }
   getApprovalManagers(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getApprovalManagers, data);
  }

 getHrmsInvoiceByOrderId(data: any) {

  return this.api.GET_BR(
    environment.VENDOR_APIS.getHrmsInvoiceByOrderId +
    "?order_id=" + data.order_id,
    data
  );
}
createSeparationCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createSeparationCategories, data);
  }
updateSeparationCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateSeparationCategories, data);
  }
getSeparationCategories(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getSeparationCategories, data);
  }
deleteSeparationCategories(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteSeparationCategories, data);
  }
getEmployeesDirectory(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmployeesDirectory, data);
  }
getUplineManagerAndReports(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.getUplineManagerAndReports, data);
  }


  createEmpOffBoardingChecklist(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createEmpOffBoardingChecklist, data);
  }
 
  updateEmpOffBoardingChecklist(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.updateEmpOffBoardingChecklist, data);
  }

  deleteEmpOffBoardingChecklist(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.deleteEmpOffBoardingChecklist, data);
  }
  getEmpOffBoardingChecklist(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getEmpOffBoardingChecklist, data);
  }
  getSeperationEmpType(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getSeperationEmpType, data);
  }
  calculateLWD(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.calculateLWD, data);
  }

  getApprovedSeparations(data: any) {
    return this.api.GET_BR(environment.VENDOR_APIS.getApprovedSeparations, data);
  }
  createHrmsEmployee(data: any) {
    return this.api.POST_BR(environment.VENDOR_APIS.createHrmsEmployee, data);
  }

}
